// ServicesTrustedAcrossIndustriesData.js

// CHEMINS D'AUDIT ET D'ASSURANCE FINANCIÈRE
export const financialStatementAuditData = {
  industries: [
    { title: "Finance", img: "/assets/icons/financial.png" },
    { title: "Technologie", img: "/assets/icons/Technology.png" },
    { title: "Immobilier", img: "/assets/icons/Real-Estate.png" },
    { title: "Santé", img: "/assets/icons/health.png" },
  ],
  heading: "EXPERTISE SECTORIELLE",
  subheading: "AUDITS ADAPTÉS À CHAQUE INDUSTRIE",
  description:
    "Chaque industrie fonctionne différemment, donc les risques à l'intérieur de chaque entreprise sont également différents. C'est pourquoi nous commençons par comprendre comment fonctionne votre secteur – comment l'argent circule, où apparaissent les problèmes courants et ce que les régulateurs attendent.",
  buttonText: "Explorer Nos Industries",
};

// SERVICE CONSEIL IFRS
export const ifrsAdvisoryServiceData = {
  industries: [
    { title: "Banque", img: "/assets/icons/financial.png" },
    { title: "Médias", img: "/assets/icons/Technology.png" },
    { title: "Logistique", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "INSIGHTS SECTORIELS",
  subheading: "EXPÉRIENCE IFRS SPÉCIFIQUE AU SECTEUR",
  description:
    "L'interprétation des IFRS varie des modèles de revenus dans les médias aux structures lourdes en contrats de location dans la logistique et aux instruments financiers dans la banque. Notre équipe formée à l'industrie comprend ces nuances et conçoit des cadres de reporting qui reflètent la réalité économique de votre entreprise.",
  buttonText: "Explorer Nos Industries",
};

// AUTRE SERVICE D'ASSURANCE
export const otherAssuranceServiceData = {
  industries: [
    { title: "Banque", img: "/assets/icons/financial.png" },
    { title: "Télécom", img: "/assets/icons/Technology.png" },
    { title: "Santé", img: "/assets/icons/health.png" },
    { title: "Manufacture", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "EXPERTISE SECTORIELLE",
  subheading: "ASSURANCE À TRAVERS DES SECTEURS DIVERSIFIÉS",
  description:
    "Les besoins d'assurance varient considérablement selon les industries - ce qui compte dans la banque ne susciterait pas la crédibilité dans les télécoms, la santé ou la manufacture. Notre équipe apporte de l'expérience à travers des secteurs à évolution rapide et lourds en actifs en adaptant nos méthodes de test, de validation et de reporting à chaque paysage de risque.",
  buttonText: "Explorer Tout",
};

// CADRE DE CONTRÔLE INTERNE
export const internalControlFrameworkData = {
  industries: [
    { title: "Banques", img: "/assets/icons/financial.png" },
    { title: "Manufacturiers", img: "/assets/icons/Real-Estate.png" },
    { title: "Télécom", img: "/assets/icons/Technology.png" },
  ],
  heading: "INDUSTRIE DANS LAQUELLE VOUS OPÉREZ",
  subheading: "CADRES SPÉCIFIQUES AU SECTEUR",
  description:
    "Les banques ont besoin d'une logique d'approbation automatisée. Les manufacturiers ont besoin de garanties opérationnelles, et ainsi de suite. Chaque industrie comporte un comportement de risque unique, et nos cadres viennent avec des solutions. Le résultat : des contrôles qui n'existent pas seulement - ils fonctionnent.",
  buttonText: "Découvrir Plus",
};
export const dealAdvisoryData = {
  industries: [
    { title: "Technologie", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Santé", img: "/assets/icons/health.png" },
    { title: "Immobilier", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "PERSPECTIVE PILOTÉE PAR LE SECTEUR",
  subheading: "DES TRANSACTIONS QUI COMPRENNENT L'ADN DE L'INDUSTRIE",
  description:
    "Notre expérience à travers la technologie, le BFSI, la santé, l'énergie, l'immobilier, la consommation, la manufacture, la logistique et les marchés numériques émergents nous aide à évaluer les transactions à travers la logique sectorielle, pas seulement les feuilles de calcul.",
  buttonText: "Il y a Plus",
};
export const restructuringData = {
  industries: [
      { title: "Technologie", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Santé", img: "/assets/icons/health.png" },
    { title: "Immobilier", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "MULTIPLES RÉALITÉS",
  subheading: "LOGIQUE DE RESTRUCTURATION POUR LE MODÈLE D'AFFAIRES",
  description:
    "La manufacture exige une optimisation de la capacité, la vente au détail dépend des cycles de trésorerie, la technologie a besoin de gestion de l'attrition, la construction repose sur la vélocité des projets et le BFSI restructure autour de la confiance réglementaire.",
  buttonText: "Il y a Plus",
};
export const dueDiligenceData = {
  industries: [
      { title: "Technologie", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Santé", img: "/assets/icons/health.png" },
    { title: "Immobilier", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "EXPOSITION SECTORIELLE",
  subheading: "NOS INDUSTRIES DE DUE DILIGENCE",
  description:
    "Nous appliquons la due diligence à travers la manufacture, la technologie, l'énergie, l'immobilier, la logistique, la vente au détail, le BFSI, la santé, et plus - chacune avec un ADN de risque différent.",
  buttonText: "Explorer Plus",
};
export const forensicServicesData = {
  industries: [
    { title: "Technologie", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Santé", img: "/assets/icons/health.png" },
    { title: "Immobilier", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "TRAVAIL FORENSIQUE À L'ÉCHELLE DU SECTEUR",
  subheading: "EXPÉRIENCE À TRAVERS DES ENVIRONNEMENTS À HAUT RISQUE",
  description:
    "Nous avons réalisé des travaux forensiques pour des entreprises confrontées à des soupçons de fraude, des litiges d'actionnaires, des infiltrations cyber, des conflits de partenaires, des collusions de fournisseurs et des fuites de trésorerie à travers les secteurs.",
  buttonText: "Discuter d'un Cas",
};
export const riskAdvisoryData = {
  industries: [
    { title: "Technologie", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Santé", img: "/assets/icons/health.png" },
    { title: "Immobilier", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "RISQUE À TRAVERS LES INDUSTRIES",
  subheading: "EXPÉRIENCE À TRAVERS DIFFÉRENTES INDUSTRIES",
  description:
    "Nous avons aidé des organisations avec le risque d'entreprise, la préparation cyber, les cadres de gouvernance, la préparation à la conformité, la stabilité opérationnelle et la planification de la continuité — à travers l'échelle, les secteurs et les modèles de propriété.",
  buttonText: "Résoudre Votre Risque",
};
export const technologyAdvisoryServiceData = {
  industries: [
   { title: "Technologie", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Santé", img: "/assets/icons/health.png" },
    { title: "Immobilier", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "EXPÉRIENCE NUMÉRIQUE",
  subheading: "CONSEIL TECH À TRAVERS LES SECTEURS",
  description:
    "Nous avons dirigé des cycles d'amélioration numérique à travers des environnements de marché intermédiaire et d'entreprise — des services financiers et de la vente au détail aux télécoms, gouvernement, santé et manufacture.",
  buttonText: "Démarrer le Changement Numérique",
};
export const valuationsData = {
  industries: [
    { title: "Technologie", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Santé", img: "/assets/icons/health.png" },
    { title: "Immobilier", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "NOTRE PROFONDEUR SECTORIELLE",
  subheading: "INSIGHT À TRAVERS LES MARCHÉS",
  description:
    "Nos analystes en valorisation apportent de l'expérience à travers la manufacture, la vente au détail, le BFSI, les entreprises soutenues par le capital-investissement, les startups technologiques, la santé, la logistique, et plus.",
  buttonText: "Discuter Plus",
};



// TABLEAUX DE DONNÉES DE FISCALITÉ
export const corporateTaxData = {
  industries: [
    { title: "Technologie", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Santé", img: "/assets/icons/health.png" },
    { title: "Immobilier", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "INTELLIGENCE FISCALE SECTORIELLE",
  subheading: "LA FISCALITÉ OPÈRE À TRAVERS LES INDUSTRIES",
  description:
    "Nous travaillons avec des entreprises à travers la manufacture, le commerce, les services financiers, la technologie, la santé et les opérations transfrontalières — nous permettant de structurer des modèles fiscaux.",
  buttonText: "Explorer l'Expertise Fiscale",
};

export const mergerAndAcquisitionData = {
  industries: [
     { title: "Technologie", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Santé", img: "/assets/icons/health.png" },
    { title: "Immobilier", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "EXPÉRIENCE À TRAVERS LES MARCHÉS",
  subheading: "CONSEIL FISCAL POUR LES ENTREPRISES",
  description:
    "Nous soutenons les acquisitions, scissions, coentreprises et réorganisations internes à travers la manufacture, la technologie, l'immobilier, les FMCG, l'énergie, la santé et les multinationales.",
  buttonText: "Demander une Consultation",
};

export const transferPricingData = {
  industries: [
    { title: "Technologie", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Santé", img: "/assets/icons/health.png" },
    { title: "Immobilier", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "OÙ NOUS OPÉRONS",
  subheading: "EXPERTISE & EXÉCUTION TRANS-SECTORIELLES",
  description:
    "Nous soutenons les groupes mondiaux à travers la manufacture, l'informatique, le BFSI, la pharma, la distribution et l'ingénierie. Chaque engagement renforce la transparence des prix tout en réduisant le risque de réévaluation à travers les frontières.",
  buttonText: "Voir l'Expérience de Cas",
};

export const valueAddedTaxData = {
  industries: [
    { title: "Technologie", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Santé", img: "/assets/icons/health.png" },
    { title: "Immobilier", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "COUVERTURE SECTORIELLE",
  subheading: "TVA À TRAVERS DES MODÈLES DIVERSIFIÉS",
  description:
    "Crédits d'entrée de manufacture, exemptions immobilières, autoliquidation commerciale, taxation des services numériques, flux de facturation du commerce électronique — la TVA se comporte différemment dans chaque industrie.",
  buttonText: "Notre Travail de Cas TVA",
};


export const internationalTaxData = {
  industries: [
    { title: "Technologie", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Santé", img: "/assets/icons/health.png" },
    { title: "Immobilier", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "À TRAVERS LES MARCHÉS & MODÈLES ",
  subheading: "EXPERTISE FISCALE DANS DES SECTEURS DIVERSIFIÉS ",
  description:"Notre expérience couvre la manufacture, l'informatique, le commerce, les services numériques, la vente au détail, les structures d'investissement et les configurations mondiales émergentes. Nous comprenons les réalités opérationnelles et affinons les voies fiscales qui fonctionnent dans le monde réel.",
  buttonText: "Explorer les Insights de Cas",
};

export const exciseTaxData = {
  industries: [
    { title: "Technologie", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Santé", img: "/assets/icons/health.png" },
    { title: "Immobilier", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "À TRAVERS LES SECTEURS RÉGLEMENTÉS",
  subheading: "EXPERTISE SECTORIELLE AVEC LA COMPLEXITÉ DE L'ACCISE",
  description:
    "Nous avons collaboré avec des manufacturiers, importateurs, acteurs FMCG, fournisseurs automobiles, entreprises liées au tabac et à l'énergie, naviguant dans l'accise dans des conditions multi-états.",
  buttonText: "Consulter les Experts Maintenant",
};

export const taxRestructuringData = {
  industries: [
    { title: "Technologie", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Santé", img: "/assets/icons/health.png" },
    { title: "Immobilier", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "UNE EXPÉRIENCE QUI LIVRE",
  subheading: "À TRAVERS DIFFÉRENTS MODÈLES D'AFFAIRES",
  description:
    "Nous avons ré-ingéniéré des structures fiscales pour des conglomérats, maisons de commerce, manufacturiers, unités de holding offshore, distributeurs de détail et entités de groupe diversifiées.",
  buttonText: "Explorer les Possibilités",
};


export const economicSubstanceRegulationsData = {
  industries: [
    { title: "Technologie", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Santé", img: "/assets/icons/health.png" },
    { title: "Immobilier", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "PROUVÉ À TRAVERS LES SECTEURS",
  subheading: "ESR POUR DIFFÉRENTES INDUSTRIES",
  description:
    "Nous avons soutenu la préparation ESR pour des sociétés holding, des hubs de distribution, des groupes d'investissement et des filiales multinationales. Notre travail réduit les pénalités, améliore le contrôle de gouvernance et renforce la confiance des autorités pendant la vérification.",
  buttonText: "Besoin de Support ESR ?",
};

export const financeAndAccountingData = {
  industries: [
    { title: "Technologie", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Santé", img: "/assets/icons/health.png" },
    { title: "Immobilier", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "EXPERTISE COMPTABLE PROUVÉE",
  subheading: "INDUSTRIES QUE NOUS RENFORÇONS FINANCIÈREMENT",
  description:
    "Nous avons géré les livres, les conformités, les structures de coûts et les cycles de reporting pour des entreprises avec des réalités — axées sur la vente au détail, basées sur des contrats, commerce à volume élevé, manufacture, etc.",
  buttonText: "Discuter de Vos Exigences !",
};
export const corporateAdvisoryServicesData = {
  industries: [
    { title: "Technologie", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Santé", img: "/assets/icons/health.png" },
    { title: "Immobilier", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "QUI NOUS AVONS CONSEILLÉ",
  subheading: "DÉCISIONS À TRAVERS DE MULTIPLES SECTEURS",
  description:
    "Nous avons soutenu des startups s'internationalisant, des entreprises de marché intermédiaire se restructurant post-pandémie, et des corporations établies entrant sur de nouveaux marchés ou revisitant leur stratégie de capital. Notre conseil aide les organisations à choisir sagement, à croître durablement et à protéger la valeur d'entreprise à chaque étape.",
  buttonText: "Discutons",
};
export const expensesClaimManagementData = {
  industries: [
    { title: "Technologie", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Santé", img: "/assets/icons/health.png" },
    { title: "Immobilier", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "PORTÉE SECTORIELLE",
  subheading: "EXPÉRIENCE À TRAVERS DES MODÈLES D'AFFAIRES DIVERSIFIÉS",
  description:
    "Nous avons soutenu des PME, des entreprises, des entreprises familiales et des entreprises mondiales dans la navigation de structures complexes de remboursement. Notre expérience garantit de fournir des cycles de réclamation plus rapides et une visibilité améliorée des coûts.",
  buttonText: "Explorer les Études de Cas",
};
export const payrollHrServicesData = {
  industries: [
    { title: "Technologie", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Santé", img: "/assets/icons/health.png" },
    { title: "Immobilier", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "À TRAVERS DES SECTEURS DIVERSIFIÉS",
  subheading: "SUPPORT DE PAIE & RH DE CONFIANCE",
  description:
    "Notre équipe gère des structures de paie grandes et petites à travers des industries telles que la vente au détail, les services professionnels, la restauration, la logistique, la santé et la technologie.",
  buttonText: "Parler aux Experts",
};
export const secondmentData = {
  industries: [
    { title: "Technologie", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Santé", img: "/assets/icons/health.png" },
    { title: "Immobilier", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "EXPERTISE SECTORIELLE",
  subheading: "SUPPORT DE DÉTACHEMENT DE CONFIANCE",
  description:
    "Nos détachés ont soutenu des organisations dans les secteurs bancaire, immobilier, manufacture, vente au détail, technologie et gouvernement pour fournir du reporting, de la conformité et du support opérationnel sans perturbation.",
  buttonText: "Explorer l'Expérience Sectorielle",
};
export const treasuryServiceData = {
  industries: [
    { title: "Technologie", img: "/assets/icons/Technology.png" },
    { title: "BFSI", img: "/assets/icons/financial.png" },
    { title: "Santé", img: "/assets/icons/health.png" },
    { title: "Immobilier", img: "/assets/icons/Real-Estate.png" },
  ],
  heading: "PROUVÉ À TRAVERS LES INDUSTRIES",
  subheading: "EXPERTISE EN TRÉSORERIE POUR DES ENTREPRISES COMPLEXES",
  description:
    "Notre équipe comprend les attentes de conformité, les pratiques bancaires et les modèles de risque uniques à chaque industrie — rendant nos solutions adaptables et fiables à travers les secteurs.",
  buttonText: "Explorer l'Expertise Sectorielle",
};
// STRATÉGIES
export const marketResearchData = {
 industries: [
    { title: "Finance", img: "/assets/icons/financial.png" },
    { title: "Technologie", img: "/assets/icons/Technology.png" },
    { title: "Immobilier", img: "/assets/icons/Real-Estate.png" },
    { title: "Santé", img: "/assets/icons/health.png" },
  ],
  heading: "EXPERTISE PROUVÉE",
  subheading: "FORCE DE RECHERCHE À TRAVERS LES INDUSTRIES",
  description: "Notre expérience à travers les marchés émergents et matures nous permet de comprendre les différences comportementales, les paysages réglementaires et les complexités sectorielles — vous aidant à naviguer les marchés en confiance.",
  buttonText: "Explorer les Insights Sectoriels",
};

export const businessConsultingData = {
 industries: [
    { title: "Finance", img: "/assets/icons/financial.png" },
    { title: "Technologie", img: "/assets/icons/Technology.png" },
    { title: "Immobilier", img: "/assets/icons/Real-Estate.png" },
    { title: "Santé", img: "/assets/icons/health.png" },
  ],
  heading: "EXPERTISE SECTORIELLE",
  subheading: "EXPERTISE POUR VOTRE INDUSTRIE",
  description: "Nos consultants apportent de l'expérience pratique à travers les industries. Chaque stratégie est ancrée dans le comportement réel du marché, la dynamique réglementaire et les réalités opérationnelles.",
  buttonText: "Explorer l'Expérience Sectorielle",
};

// SERVICES AUX ENTREPRISES
export const entitySetupData = {
  industries: [
    { title: "Finance", img: "/assets/icons/financial.png" },
    { title: "Technologie", img: "/assets/icons/Technology.png" },
    { title: "Immobilier", img: "/assets/icons/Real-Estate.png" },
    { title: "Santé", img: "/assets/icons/health.png" },
  ],
  heading: "EXPERTISE TRANS-SECTORIELLE",
  subheading: "CONSTITUTION D'ENTITÉ POUR CHAQUE ENTREPRISE",
  description: "Nous avons soutenu la formation d'entreprise à travers les industries, y compris le commerce, la manufacture, la technologie, la finance, la santé, la logistique et les services professionnels.",
  buttonText: "Explorer les Services aux Entreprises",
};

export const outsourcedFinanceRegulatoryComplianceData = {
 industries: [
    { title: "Finance", img: "/assets/icons/financial.png" },
    { title: "Technologie", img: "/assets/icons/Technology.png" },
    { title: "Immobilier", img: "/assets/icons/Real-Estate.png" },
    { title: "Santé", img: "/assets/icons/health.png" },
  ],
  heading: "EXPERTISE TRANS-SECTORIELLE",
  subheading: "SOLUTIONS DE CONFORMITÉ POUR CHAQUE INDUSTRIE",
  description: "Notre expérience couvre des secteurs réglementés avec différentes attentes financières et de conformité, adaptant les cadres pour les rencontrer avec rapidité et exactitude.",
  buttonText: "Nos Capacités Sectorielles",
};

export const companySecretarialData = {
  industries: [
    { title: "Finance", img: "/assets/icons/financial.png" },
    { title: "Technologie", img: "/assets/icons/Technology.png" },
    { title: "Immobilier", img: "/assets/icons/Real-Estate.png" },
    { title: "Santé", img: "/assets/icons/health.png" },
  ],
  heading: "NOTRE DOSSIER DE GOUVERNANCE",
  subheading: "CONFIANCE DE SECTEURS DIVERSIFIÉS",
  description: "Nous soutenons les entreprises avec différentes structures de gouvernance, pressions réglementaires et changements corporatifs continus, livrant une conformité constante et une clarté opérationnelle.",
  buttonText: "Explorer Notre Expérience",
};